var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loanType=='InstrumentUltimateTzSalaryAdvance')?_c('SalaryAdvance',{attrs:{"customer":_vm.customer}}):(_vm.loanType=='InstrumentUltimateTzCheckMeBack')?_c('CheckMeBack',{attrs:{"customer":_vm.customer}}):_c('InEligible',{attrs:{"customer":_vm.customer}})
}
var staticRenderFns = []

export { render, staticRenderFns }